
import { MapPin } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

const LocationFormHeader = () => {
  return (
    <Alert className="bg-blue-50 border-blue-200">
      <MapPin className="h-4 w-4 text-blue-600" />
      <AlertTitle className="text-blue-800">Why your location matters</AlertTitle>
      <AlertDescription className="text-blue-700">
        Your location helps us provide region-specific legal information in your refund requests. 
        Different countries and regions have different consumer protection laws, and we use this 
        information to strengthen your case with relevant legal context.
      </AlertDescription>
    </Alert>
  );
};

export default LocationFormHeader;
